export default (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M24.8399 5.58567L20.695 1.4315C20.2717 1.00841 19.6985 0.769192 19.1002 0.769192L0.50781 0.765627L0.507811 8.49734L12.3051 8.49734L0.507812 20.2904L0.507812 25.7656L5.96892 25.7656L17.7751 13.9636L17.7751 25.7656L25.5078 25.7656L25.4989 7.17451C25.4989 6.57825 25.2614 6.00698 24.8399 5.58389L24.8399 5.58567Z"
            fill="white"
        />
    </svg>
)
